'use client';

import { Box, Button, Grid, Typography } from "@mui/material";
import { useRouter } from "@/i18n/routing";

const FooterFaq = () => {
    const router = useRouter();

    return (
        <Box sx={{ py: 10, backgroundColor: "#132c4b", color: "white" }}>
            <Grid container sx={{ maxWidth: "lg", margin: "auto", px: 2.5 }}>
                <Grid size={12} sx={{ textAlign: "center" }}>
                    <Typography
                        variant="h4"
                        component="h2"
                        sx={{
                            fontWeight: 800,
                            mb: 3,
                        }}
                    >
                        お問い合わせ
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: '#e2e8f0',
                            mb: 2,
                            maxWidth: 'md',
                            mx: 'auto'
                        }}
                    >
                        解決しない疑問がございましたら、お気軽にお問い合わせください。専門スタッフが丁寧に対応いたします。
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: '#e2e8f0',
                            mb: 6,
                            maxWidth: 'md',
                            mx: 'auto'
                        }}
                    >
                        AirXpress公式サイトの「お問い合わせフォーム」よりご連絡いただけます。
                    </Typography>

                    <Button
                        variant="contained"
                        size="large"
                        sx={{
                            backgroundColor: '#F15859',
                            fontWeight: 'bold',
                            px: 6,
                            py: 1.5,
                            fontSize: '1rem',
                            borderRadius: '10px',
                            boxShadow: '0 4px 14px 0 rgba(225, 29, 72, 0.39)',
                            '&:hover': {
                                backgroundColor: '#be123c'
                            }
                        }}
                        onClick={() => {
                            router.push('/contact');
                        }}
                    >
                        お問い合わせ
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default FooterFaq;